"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var TitleResource = /** @class */ (function (_super) {
    tslib_1.__extends(TitleResource, _super);
    function TitleResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TitleResource.endpoint = '/titles';
    TitleResource.MODEL_NAME = 'title';
    return TitleResource;
}(base_1.default));
exports.default = TitleResource;
//# sourceMappingURL=title.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/system/title.js
// module id = tjbc
// module chunks = 0